import {
    SET_RECOMMENDATION_DATA,
    SET_STAGES_DATA,
  } from "../constant";
  
  const initialState = {
    stages: [],
  };
  
  const stagesReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_STAGES_DATA:
        return {
          ...state,
          stages: action.payload.stages,
        };
      case SET_RECOMMENDATION_DATA:
        return {
          ...state,
          stages: action.payload.stages,
        };
      default:
        return state;
    }
  };
  
  export { stagesReducer };
  